import React from "react";
import "../css/terms.scss";

function Terms() {
  return (
    <div className="terms">
      <div className="policy-container">
        <h1>Terms of Service</h1>
        <p>
          All content on this site, including, but not limited to information,
          content, graphics, images, and program code such as HTML and
          JavaScript are the copyright 2026 of isanroute and may not be
          reproduced in any manner without written consent. We apologise if
          prices have not been translated or displayed correctly under human
          error.
        </p>
        <p>
          isanroute aims to provide accurate product descriptions and fair prices. We try
          not to enter into Sale all that often as it does not make commercial
          sense on our margins. We always charge a fair price and in some cases
          discount for friends, family and good customers. This applies in-store
          only and we encourage you to visit our store and support your local
          business. Our online store represents our brand internationally and we
          hope to offer something original in both product and experience.
        </p>
        <h2>Orders and Payment</h2>
        <p>Orders are accepted only after successful payment confirmation. We may cancel an order affected by an inventory error, pricing error, suspected fraud or delivery restriction and will return any captured payment.</p>
        <h2>Shipping and Returns</h2>
        <p>A $9.99 USD shipping fee applies at checkout. Delivery estimates are not guarantees. Returns are subject to the conditions stated in our Refund Policy.</p>
        <h2>Product Information</h2>
        <p>We make reasonable efforts to show colors, materials and measurements accurately. Display settings and normal production variation may cause minor differences.</p>
        <h2>Contact</h2>
        <p>Questions about these terms may be sent to send@isanroute.space.</p>
      </div>
    </div>
  );
}

export default Terms;
